<!--Formulaire des généralités de la règle d'attribution-->
<fieldset ngModelGroup="regle-attribution-generalites">
    <mat-card>
        <!--Titre du bloc généralités-->
        <mat-card-title>
            <span [translate]="'admin.frais.indemnites.reglesAttribution.detail.generalites.title'"></span>
        </mat-card-title>

        <mat-card-content>
            <div class="row">
                <!--Colonne gauche : Libellé / Mode / Disponible-->
                <div class="col-md-6 col-sm-12 pr-md-4">
                    <div class="row">
                        <custom-input ngDefaultControl
                                      name="libelle"
                                      customType="input"
                                      [lCol]="4"
                                      [rCol]="8"
                                      [(ngModel)]="regleAttribution.libelle"
                                      [required]="true"
                                      [maxlength]="255"
                                      libelle="admin.frais.indemnites.reglesAttribution.detail.generalites.libelle">
                        </custom-input>
                    </div>

                    <div class="row">
                        <custom-input ngDefaultControl
                                      name="modeGestion"
                                      customType="select"
                                      [lCol]="4"
                                      [rCol]="8"
                                      [(ngModel)]="regleAttribution.modeGestion"
                                      (onChange)="onModeGestionChange()"
                                      [required]="true"
                                      [selectOptions]="[
                                          {code: TypeModeGestion.UNE_FOIS_PAR_JOUR, libelle: 'admin.frais.indemnites.reglesAttribution.liste.modesGestion.uneFoisParJour' | translate},
                                          {code: TypeModeGestion.TEMPS_PASSE, libelle: 'admin.frais.indemnites.reglesAttribution.liste.modesGestion.tempsPasse' | translate},
                                          {code: TypeModeGestion.TRANCHE_HORAIRE, libelle: 'admin.frais.indemnites.reglesAttribution.liste.modesGestion.trancheHoraire' | translate}
                                      ]"
                                      optionValue="code"
                                      optionDisplay="libelle"
                                      [postTooltip]="getModeGestionTooltip() | translate"
                                      libelle="admin.frais.indemnites.reglesAttribution.detail.generalites.modeGestion">
                        </custom-input>
                    </div>

                    <!--Lignes des champs conditionnels selon le mode TRANCHE_HORAIRE-->
                    <div class="row" *ngIf="regleAttribution.modeGestion === TypeModeGestion.TRANCHE_HORAIRE">
                        <div class="col-4 text-right pt-3">
                            <label [translate]="'admin.frais.indemnites.reglesAttribution.detail.generalites.trancheHoraire'"></label>
                        </div>
                        <div class="col-8 p-0">
                            <div class="row align-items-center no-gutters">
                                <div class="col-5 pr-1" style="min-width: 160px;">
                                    <custom-input ngDefaultControl
                                                  name="heureDeb"
                                                  customType="heure"
                                                  [lCol]="0"
                                                  [rCol]="12"
                                                  [(ngModel)]="regleAttribution.heureDeb"
                                                  (input)="onHoraireChange()"
                                                  (keydown)="onHoraireKeydown($event, 'heureDeb')"
                                                  (focusout)="completerMinutes('heureDeb')"
                                                  [required]="true">
                                    </custom-input>
                                </div>
                                <div class="col-1 d-flex align-items-center justify-content-center h-100">
                                    <span class="d-inline-block" [translate]="'admin.frais.indemnites.reglesAttribution.detail.generalites.trancheHoraireSeparateur'"></span>
                                </div>
                                <div class="col-5 pl-1 position-relative" style="min-width: 160px;">
                                    <custom-input ngDefaultControl
                                                  name="heureFin"
                                                  customType="heure"
                                                  [lCol]="0"
                                                  [rCol]="12"
                                                  [(ngModel)]="regleAttribution.heureFin"
                                                  (input)="onHoraireChange()"
                                                  (keydown)="onHoraireKeydown($event, 'heureFin')"
                                                  (focusout)="completerMinutes('heureFin')"
                                                  [required]="true">
                                    </custom-input>
                                    <mat-icon *ngIf="isHeureFinWarning()"
                                              style="position: absolute; right: -28px; top: 14px;"
                                              class="material-icons-outlined"
                                              color="warn"
                                              [matTooltip]="'admin.frais.indemnites.reglesAttribution.detail.generalites.trancheHoraireTooltipWarningChevalDeuxJours' | translate"
                                              matTooltipPosition="right">warning</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" *ngIf="regleAttribution.modeGestion === TypeModeGestion.TRANCHE_HORAIRE">
                        <div class="col-4 text-right pt-3">
                            <label [translate]="'admin.frais.indemnites.reglesAttribution.detail.generalites.couverturePartielle'"></label>
                        </div>
                        <div class="col-8 p-0">
                            <custom-input ngDefaultControl
                                          name="couverturePartielle"
                                          customType="checkbox"
                                          [lCol]="0"
                                          [rCol]="12"
                                          [ngModel]="regleAttribution.couverturePartielle"
                                          [(customModel)]="regleAttribution.couverturePartielle"
                                          postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.couverturePartielleDescription">
                            </custom-input>
                        </div>
                    </div>

                    <!--Ligne des champs conditionnels selon le mode TEMPS_PASSE-->
                    <div class="row" *ngIf="regleAttribution.modeGestion === TypeModeGestion.TEMPS_PASSE">
                        <custom-input ngDefaultControl
                                      name="dureeMin"
                                      customType="number"
                                      [lCol]="4"
                                      [rCol]="2"
                                      [(ngModel)]="regleAttribution.dureeMin"
                                      [suffix]="dureeMinTooltips"
                                      [min]="0"
                                      [nbDecimales]="0"
                                      libelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dureeMin">
                        </custom-input>

                        <custom-input ngDefaultControl
                                      name="dureeMax"
                                      customType="number"
                                      [lCol]="4"
                                      [rCol]="2"
                                      [(ngModel)]="regleAttribution.dureeMax"
                                      [suffix]="dureeMaxTooltips"
                                      [min]="0"
                                      [nbDecimales]="0"
                                      libelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dureeMax">
                        </custom-input>

                        <ng-template #dureeMinTooltips>
                            <mat-icon class="material-icons-outlined"
                                      [matTooltip]="'admin.frais.indemnites.reglesAttribution.detail.generalites.dureeMinTooltipInfo' | translate"
                                      matTooltipPosition="right">info</mat-icon>
                            <mat-icon *ngIf="isDureeMinWarning()"
                                      color="warn"
                                      [matTooltip]="'admin.frais.indemnites.reglesAttribution.detail.generalites.dureeMinTooltipWarningRange' | translate"
                                      matTooltipPosition="right">warning</mat-icon>
                        </ng-template>

                        <ng-template #dureeMaxTooltips>
                            <mat-icon *ngIf="isDureeMaxRangeWarning()"
                                      color="warn"
                                      [matTooltip]="'admin.frais.indemnites.reglesAttribution.detail.generalites.dureeMinTooltipWarningRange' | translate"
                                      matTooltipPosition="right">warning</mat-icon>
                            <mat-icon *ngIf="isDureeMaxWarning()"
                                      color="warn"
                                      [matTooltip]="'admin.frais.indemnites.reglesAttribution.detail.generalites.dureeMaxTooltipWarningMinSuperieur' | translate"
                                      matTooltipPosition="right">warning</mat-icon>
                        </ng-template>
                    </div>

                    <div class="row mt-2">
                        <div class="col-4 text-right pt-3">
                            <label [translate]="'admin.frais.indemnites.reglesAttribution.detail.generalites.disponible'"></label>
                        </div>
                        <div class="col-8 p-0">
                            <div class="row">
                                <div class="col-6">
                                    <custom-input ngDefaultControl name="dispLu" customType="checkbox" [lCol]="0" [rCol]="12" [ngModel]="regleAttribution.dispLu" [(customModel)]="regleAttribution.dispLu" postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dispLu"></custom-input>
                                    <custom-input ngDefaultControl name="dispMa" customType="checkbox" [lCol]="0" [rCol]="12" [ngModel]="regleAttribution.dispMa" [(customModel)]="regleAttribution.dispMa" postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dispMa"></custom-input>
                                    <custom-input ngDefaultControl name="dispMe" customType="checkbox" [lCol]="0" [rCol]="12" [ngModel]="regleAttribution.dispMe" [(customModel)]="regleAttribution.dispMe" postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dispMe"></custom-input>
                                    <custom-input ngDefaultControl name="dispJe" customType="checkbox" [lCol]="0" [rCol]="12" [ngModel]="regleAttribution.dispJe" [(customModel)]="regleAttribution.dispJe" postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dispJe"></custom-input>
                                </div>
                                <div class="col-6">
                                    <custom-input ngDefaultControl name="dispVe" customType="checkbox" [lCol]="0" [rCol]="12" [ngModel]="regleAttribution.dispVe" [(customModel)]="regleAttribution.dispVe" postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dispVe"></custom-input>
                                    <custom-input ngDefaultControl name="dispSa" customType="checkbox" [lCol]="0" [rCol]="12" [ngModel]="regleAttribution.dispSa" [(customModel)]="regleAttribution.dispSa" postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dispSa"></custom-input>
                                    <custom-input ngDefaultControl name="dispDi" customType="checkbox" [lCol]="0" [rCol]="12" [ngModel]="regleAttribution.dispDi" [(customModel)]="regleAttribution.dispDi" postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dispDi"></custom-input>
                                    <custom-input ngDefaultControl name="dispJF" customType="checkbox" [lCol]="0" [rCol]="12" [ngModel]="regleAttribution.dispJF" [(customModel)]="regleAttribution.dispJF" postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.dispJF"></custom-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Colonne droite : Actif / Applicable-->
                <div class="col-md-6 col-sm-12 pl-md-4 mt-3 mt-md-0">
                    <div class="row">
                        <custom-input ngDefaultControl
                                      name="actif"
                                      customType="checkbox"
                                      [lCol]="3"
                                      [rCol]="9"
                                      [ngModel]="regleAttribution.actif"
                                      [(customModel)]="regleAttribution.actif"
                                      libelle="admin.frais.indemnites.reglesAttribution.detail.generalites.actif"
                                      postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.activeIndemnite">
                        </custom-input>
                    </div>

                    <div class="row mt-2">
                        <custom-input ngDefaultControl
                                      name="typeMissionCalendaire"
                                      customType="select"
                                      [lCol]="3"
                                      [rCol]="8"
                                      [(ngModel)]="typeMissionCalendaire"
                                      [required]="true"
                                      [selectOptions]="[
                                          {code: TypeMissionCalendaire.AUCUN, libelle: 'global.input.choisissez' | translate},
                                          {code: TypeMissionCalendaire.TOUTES_MISSIONS, libelle: 'admin.frais.indemnites.reglesAttribution.detail.generalites.toutesMissions' | translate},
                                          {code: TypeMissionCalendaire.MISSION_N_EXCEDANT_PAS_UN_JOUR, libelle: 'admin.frais.indemnites.reglesAttribution.detail.generalites.aucunExcedantCalendaire' | translate},
                                          {code: TypeMissionCalendaire.MISSION_EXCEDANT_UN_JOUR, libelle: 'admin.frais.indemnites.reglesAttribution.detail.generalites.excedantCalendaire' | translate}
                                      ]"
                                      optionValue="code"
                                      optionDisplay="libelle"
                                      libelle="admin.frais.indemnites.reglesAttribution.detail.generalites.applicable">
                        </custom-input>
                    </div>

                    <div class="row">
                        <div class="col-3"></div>
                        <div class="col-8 p-0">
                            <div class="row">
                                <div class="col-12">
                                    <custom-input ngDefaultControl
                                                  name="applicablePremJour"
                                                  customType="checkbox"
                                                  [lCol]="0"
                                                  [rCol]="12"
                                                  [ngModel]="regleAttribution.applicablePremJour"
                                                  [(customModel)]="regleAttribution.applicablePremJour"
                                                  [disabled]="isApplicablePremJourDisabled()"
                                                  postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.applicablePremJour">
                                    </custom-input>
                                    <custom-input ngDefaultControl
                                                  name="applicableJourInterm"
                                                  customType="checkbox"
                                                  [lCol]="0"
                                                  [rCol]="12"
                                                  [ngModel]="regleAttribution.applicableJourInterm"
                                                  [(customModel)]="regleAttribution.applicableJourInterm"
                                                  [disabled]="typeMissionCalendaire === TypeMissionCalendaire.MISSION_N_EXCEDANT_PAS_UN_JOUR"
                                                  postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.applicableJourInterm">
                                    </custom-input>
                                    <custom-input ngDefaultControl
                                                  name="applicableDernJour"
                                                  customType="checkbox"
                                                  [lCol]="0"
                                                  [rCol]="12"
                                                  [ngModel]="regleAttribution.applicableDernJour"
                                                  [(customModel)]="regleAttribution.applicableDernJour"
                                                  [disabled]="typeMissionCalendaire === TypeMissionCalendaire.MISSION_N_EXCEDANT_PAS_UN_JOUR"
                                                  postLibelle="admin.frais.indemnites.reglesAttribution.detail.generalites.applicableDernJour">
                                    </custom-input>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </mat-card-content>
    </mat-card>
</fieldset>
